import { Injectable } from '@angular/core';

import { TourService } from './tour.service';
import { TourIntentService } from './tour-intent.service';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TourIntentGuard {
  constructor(private tours: TourService, private intent: TourIntentService) {}

  canActivate(): Observable<boolean> {
    const next = this.intent.consumeIntent();
    if (!next) return of(true);
    return this.tours.init$(next.key as any, (next.options ?? {}) as any).pipe(
      switchMap(() => this.tours.start$()),
      take(1),
      switchMap(() => of(true))
    );
  }
}
